<!--主体信息列表跳转过来显示的详情页-->
<template>
    <div>
        <header>
            <div class="header-title">
                <div style="display: flex; align-items: center;">
                    <p>自然人基本信息</p>
                    <span class="basic-top-btn" @click="goChangeList">查看历史变更记录</span>
                </div>
               <div>
                   <el-button v-if="state != -1" type="primary" class="header-right-more" @click="toChange()">发起变更</el-button>
               </div>
            </div>
        </header>
        <div class="container">
            <div class="card-item">
                <div class="card-title" style="display: flex;justify-content: space-between;align-items: center;">
                    <span>基本信息</span>
                </div>
                <div class="card-content">
                    <el-form :model="ruleForm" label-width="170px">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="姓名 : " size="small">
                                    <span>{{ruleForm.manName}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系电话 : " size="small">
                                    <span>{{ruleForm.contractTel}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="身份证件类型 : " size="small">
                                    <span>{{ruleForm.idCardName}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="身份证件号码 : " size="small">
                                    <span>{{ruleForm.idCard}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="身份证件失效日期 : " size="small">
                                    <span>{{ruleForm.idExpirationTime}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="工作单位 : " size="small">
                                    <span>{{ruleForm.workPlace}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item label="居住地址 : " size="small">
                                    <span>{{ruleForm.linkAddrName}}&nbsp;&nbsp;&nbsp;&nbsp;{{ruleForm.detailAddress}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="保证金银行账号 : " size="small">
                                    <span>{{ruleForm.securityAmountBankNumber}}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="保证金银行账号开户行 : " size="small">
                                    <span>{{ruleForm.bankName}}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="交易主体角色类型 : " prop="traddingMainTypes" size="small">
                                    <el-checkbox-group v-model="ruleForm.traddingMainTypesArr">
                                        <div class="all-deal-type">
                                            <div class="item-deal-type">
                                                <div class="item-deal-title">国有产权交易</div>
                                                <div class="item-deal-content">
                                                    <el-row>
                                                        <el-col>
                                                            <el-checkbox label="1515390002424019" disabled>竞买人</el-checkbox>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                            </div>
                                            <div class="item-deal-type">
                                                <div class="item-deal-title">国土交易</div>
                                                <div class="item-deal-content">
                                                    <el-row>
                                                        <el-col>
                                                            <el-checkbox label="1515390002424020" disabled>竞买人</el-checkbox>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                            </div>
                                        </div>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="身份证件信息 : " size="small">
                                    <docUploadView
                                            :type="type"
                                            :docItem.sync="ruleForm.attachmentParamList[0]"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="其他附件信息 : " size="small">
                                    <docUploadView
                                            :type="type"
                                            :docItem.sync="ruleForm.attachmentParamList[1]"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="bottom-btn">
<!--            <el-button @click="toExitPage()">返回</el-button>-->
        </div>
<!--        <div class="bottom-btn">-->
<!--            <el-button type="primary">通过</el-button>-->
<!--            <el-button  type="danger">不通过</el-button>-->
<!--            <el-button>返回</el-button>-->
<!--        </div>-->
        <loadingTel v-if="loadingFlag" />
    </div>
</template>
<script>
    import {mapState} from "vuex";
    export default {
        data(){
            return {
                loadingFlag:false,
                ruleForm: {
                    manName: '',
                    contractTel: '',
                    idType: '',
                    idCard: '',
                    idCardName: '',
                    idExpirationTime: '',
                    workPlace: '',
                    linkAddr: [],
                    securityAmountBankNumber: '',
                    bankName: '',
                    traddingMainTypes: '',
                    traddingMainTypesArr: [],
                    detailAddress: '',
                    linkAddrName: '',
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }, {//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                    fileList1: [],
                    fileList2: [],
                },
                id:'',
                state:'',
                type: 'ent_base_info',
            }
        },
        created() {
            this.getRouterQuery();
            this.getBasicInfoMsg();
        },
        computed: {
            ...mapState({
                entId: state => state.user.userinfo.userId,
            })
        },
        methods:{
            getRouterQuery(){
                this.id = this.$route.query.id;
            },
            // 获取数据
            getBasicInfoMsg(){
                this.$http.post('/personbaseinfo/getbyid?id='+this.entId).then((res)=>{
                    if(res.data.code == 1){
                        this.ruleForm.manName = res.data.data.manName;
                        this.ruleForm.contractTel = res.data.data.contractTel;
                        this.ruleForm.idType = res.data.data.idType;
                        this.ruleForm.idCard = res.data.data.idCard;
                        this.ruleForm.idCardName = res.data.data.idCardName;
                        this.ruleForm.idExpirationTime = res.data.data.idExpirationTime ? res.data.data.idExpirationTime.substring(0,11) : '';
                        this.ruleForm.workPlace = res.data.data.workPlace;
                        this.ruleForm.linkAddr = res.data.data.linkAddr;
                        this.ruleForm.securityAmountBankNumber = res.data.data.securityAmountBankNumber;
                        this.ruleForm.bankName = res.data.data.bankName;
                        this.ruleForm.traddingMainTypes = res.data.data.traddingMainTypes;
                        this.ruleForm.traddingMainTypesArr = res.data.data.traddingMainTypes.split(',');
                        this.ruleForm.detailAddress = res.data.data.detailAddress;
                        this.ruleForm.linkAddrName = res.data.data.linkAddrName;
                        if(res.data.data.attachmentParamList.length > 0){
                            this.ruleForm.attachmentParamList = res.data.data.attachmentParamList;
                        }
                        this.state = res.data.data.state;
                    }else{
                        this.$notify({
                            title: '自然人基本信息展示',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                })
            },
            toExitPage(){
                this.$emit('update:exitFlag',true);
                this.$emit('update:viewFlag',false);
            },
            //发起变更
            toChange(){
                this.loadingFlag = true;
                this.$http.post('/change/hpersonbaseinfo/change?personId='+this.entId).then(res=>{
                    if(res.data.code == 1){
                        this.loadingFlag = false;
                        this.$notify({
                            title: '发起变更',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'success'
                        })
                        this.$router.push({path:'/naturalBasicInformationChange/natural-basicInfo-form',query:{changeId:res.data.data.id,changeRecordId:res.data.data.changeRecordId}})
                    }else{
                        this.loadingFlag = false;
                        this.$notify({
                            title: '发起变更',
                            message: res.data.msg,
                            position: 'bottom-right',
                            type: 'warning'
                        })
                    }
                })

            },
            goChangeList(){
                this.$router.push({path:'/changeHistory-change-list'})
            }
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .el-input {
        width: 324px;
    }

    /deep/ .el-textarea__inner {
        width: 658px;
        height: 156px;
    }
    header{
        height: 68px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        .header-title {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 0 0;
            p {
                font-size: 18px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-left: 32px;
            }
        }
    }
    .container{
        margin: 20px;
        .basic-top-btn{
            width: 112px;
            height: 22px;
            font-size: 14px;
            color: #1890FF;
            line-height: 22px;
            margin-left: 12px;
            margin-top: 2px;
            text-align: center;
            cursor:pointer;
        }
        .all-deal-type {
            display: flex;

            .item-deal-type {
                width: 480px;
                border: 1px solid #EEEEEE;
                border-radius: 4px 4px 0px 0px;

                .item-deal-title {
                    width: 100%;
                    height: 45px;
                    background: #FAFAFA;
                    border-radius: 2px 2px 0px 0px;
                    border-bottom: 1px solid #EEEEEE;
                    text-align: center;
                    line-height: 45px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }

                .item-deal-content {
                    padding: 15px;
                    display: flex;
                    justify-content: center;
                }
            }

            .item-deal-type:nth-last-child(1) {
                border-left: 0;
            }
        }
    }
</style>